import {
    Box,
    Button,
    Card,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';


const PHSResultView = ({
    typeOfRequests,
    data,
    ...props
}) => {
    return (
        <Grid container>
            <Grid xs item>
                <div style={{ display: 'grid'}}>
                    <Button
                        size="large"
                        color='primary'
                        sx = {{
                            textAlign: 'center',
                            pointerEvents: 'none'
                        }}
                    >
                        {
                            typeOfRequests == 'booked' ? 
                            "TCS Below 40 PHS Leaderboard - Requests Booked" :
                            "TCS Below 40 PHS Leaderboard - Requests Fulfilled"
                        } 
                    </Button>
                </div>
                <Card
                    elevation={0}
                >
                    <PerfectScrollbar>
                        <Box sx={{}}>
                            <TableContainer sx={{ maxHeight: 500 }}>
                                <Table
                                    stickyHeader
                                    aria-label="PHS data"
                                    id="phs-list"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>City</TableCell>
                                            <TableCell>Onsite PHS Requests Booked</TableCell>
                                            <TableCell>Pathology (Home) PHS Requests Booked</TableCell>
                                            <TableCell>ECG (Center) PHS Requests Booked</TableCell>
                                            <TableCell>Total(Sum)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {(data.length > 0
                                            ? data
                                            : []
                                        ).map((phsRecord, idx) => (
                                            <TableRow hover key={idx}>
                                                <TableCell>{phsRecord.city}</TableCell>
                                                <TableCell>{typeOfRequests == 'booked' ? phsRecord.onsite_phs_requests_booked : phsRecord.onsite_phs_requests_fulfilled}</TableCell>
                                                <TableCell>{typeOfRequests == 'booked' ? phsRecord.pathology_phs_requests_booked : phsRecord.pathology_phs_requests_fulfilled} </TableCell>
                                                <TableCell>{typeOfRequests == 'booked' ? phsRecord.ecg_phs_requests_booked : phsRecord.ecg_phs_requests_fulfilled}</TableCell>
                                                <TableCell>{
                                                    typeOfRequests == 'booked' ? (
                                                        +phsRecord.onsite_phs_requests_booked +
                                                        +phsRecord.pathology_phs_requests_booked +
                                                        +phsRecord.ecg_phs_requests_booked) : (
                                                        +phsRecord.onsite_phs_requests_fulfilled +
                                                        +phsRecord.pathology_phs_requests_fulfilled +
                                                        +phsRecord.ecg_phs_requests_fulfilled
                                                    )
                                                }
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </PerfectScrollbar>
                </Card>
            </Grid>
        </Grid>
    );
}

export default PHSResultView;